import {Button, Modal} from 'antd'
import {LayoutContext} from 'components/layouts/Default/LayoutContext'
import _ from 'lodash'
import Async from 'modules/asyncCache/components/Async'
import useTranslate from 'modules/local/useTranslate'
import {useHistory} from 'modules/navigation/useRouter'
import React, {useCallback, useContext, useMemo, useState,} from 'react'
import {useLocation} from 'react-use'
import {branch, compose} from 'recompose'
import {ContentNotFound} from 'views/AppLocals/ContentNotFound'
import {showConfirmDialog, showDeleteConfirmDialog} from 'views/AppLocals/factory/createConfirmDialog'
import createContextMenu from 'views/AppLocals/factory/createContextMenu'
import {bindQueryParam, bindQueryParams,} from 'views/AppLocals/functions/routerHelper'
import usePaginationHelper, {createPagerKey,} from 'views/AppLocals/hooks/usePaginationHelper'
import {getResponseItem, NullAsDefault} from 'views/Shared'
import {product_update_Api, shop_getProducts_Api} from "../../../../apis";
import {IoWarning} from "react-icons/io5";
import {useRouteSearchParam} from "../../../../envs/_current/history";
import {bindingSearch} from "../../../Shared/components/PagerControls";
import {pagerControls, renderIf} from "../../../Shared";
import {PiCheckCircle} from "react-icons/pi";
import classNames from "classnames";
import {BiSolidEdit, BiTrash} from "react-icons/bi";
import LoadingBlock from "../../../Loading/LoadingBlock";
import {renderManagedProduct} from "../functions/renderManagedProduct";
import CRUD from "../../../Shared/enums/CRUD";
import useProductActions from "../../../AppLocals/Shop/functions/useProductActions";
import {ProductFormEdit} from "../../../AppLocals/Shop/components/ProductForm";
import {EntityPaginationMeta} from "../../../AppLocals/EntityList";

const renderGridMeta = (props) =>
    (
        <LayoutContext.Consumer>
            {({isLg}) => (
                <div className={classNames(isLg ? 'col-span-2' : 'col-span-1')}>
                    <EntityPaginationMeta
                        {...props}
                        style={{position: 'inherit'}}
                    />
                </div>
            )}
        </LayoutContext.Consumer>
    )


const ShopProducts = ({
                          showHeader = true,
                          shop_id,
                          controls = pagerControls,
                          filter_actions = {
                              status: 'product-status',
                              sortBy: 'sort-by',
                              keyword: 'keyword'
                          },
                      }) => {
    const t = useTranslate()

    const history = useHistory()

    const location = useLocation()

    const {isSm} = useContext(LayoutContext)

    const keyword = useRouteSearchParam(filter_actions.keyword)
    const sortBy = useRouteSearchParam(filter_actions.sortBy)
    const status = useRouteSearchParam(filter_actions.status)

    const [action, setAction] = useState({
        type: undefined,
        value: undefined,
    })

    const onCancel = () => {
        setAction({})
    }

    const {
        refreshKey,
        createNewProduct,
        editProductInfo,
        deleteProduct,
        publishProduct,
        addVariant,
        editVariantInfo,
        deleteVariant
    } = useProductActions({
        onRefresh: onCancel,
        onCancel: onCancel,
    })

    const confirmPublish = (id) => {
        if (id) {
            showConfirmDialog({
                icon: <IoWarning className="anticon"/>,
                translate: t,
                title: 'publish product',
                message: 'are you sure you want to publish this product',
                onOk: () => {
                    publishProduct({}, {id})
                },
            })
        }
    }

    const confirmDelete = (id) => {
        if (id) {
            showDeleteConfirmDialog({
                translate: t,
                onOk: () => {
                    deleteProduct({}, {id})
                },
            })
        }
    }

    const handleAction = (action, params) => {
        const product_id = params?.id
        switch (action) {
            case CRUD.UPDATE:
                setAction({type: action, value: params})
                break
            case "PUBLISH":
                confirmPublish(product_id)
                break
            case CRUD.DELETE:
                confirmDelete(product_id)
                break
            default:
                break
        }
    }

    const renderContextMenu = useCallback((item) => {

        return createContextMenu(
            [
                {
                    label: 'edit',
                    icon: <BiSolidEdit size={14} className="text-blue-500"/>,
                    key: CRUD.UPDATE,
                },
                {
                    label: 'delete',
                    icon: <BiTrash size={14} className="text-primary-300"/>,
                    key: CRUD.DELETE,
                },
            ],
            (key) => {
                handleAction(key, item)
            }
        )
    }, [])

    const renderActions = useCallback((item) => {

        return [
            {
                label: 'publish',
                icon: <PiCheckCircle size={13}/>,
                key: "PUBLISH",
                buttonParams: {
                    type: "default",
                    className: 'bg-green-200 hover:bg-green-500 border border-green-700 hover:border-green-700 text-green-700 hover:text-white tracking-wide leading-tight',
                }
            },
        ]
            .map((e, i) => (
                <Button key={i}
                        size="small"
                        type={e?.buttonParams?.type}
                        icon={renderIf(!isSm, e?.icon)}
                        style={{fontSize: '0.75rem'}}
                        className={classNames("flex flex-center gap-2 button-rounded-md px-2 font-medium", e?.buttonParams?.className)}
                        onClick={() => {
                            handleAction(e?.key, item)
                        }}>
                    {t(e?.label)}
                </Button>
            ))
    }, [])

    const modal = useMemo(() => {
        const {id} = action?.value ?? {}
        let title
        let Content = NullAsDefault
        let Wrapper = ({children}) => children({initialValues: {}})
        let params = {title: undefined}
        let modal_params = {}
        switch (action?.type) {
            case CRUD.UPDATE:
                title = (
                    <div className="text-center font-bold text-color-000 uppercase tracking-wide">
                        {t('edit product')}
                    </div>
                )
                params = {
                    onCancel,
                    onSubmit: (values) => {
                        editProductInfo(values, {id})
                    },
                }
                modal_params = {
                    width: 720,
                }
                Content = ProductFormEdit
                Wrapper = ({children}) => (
                    <Async
                        {...{
                            query: bindQueryParam({id}),
                            apiInfo: product_update_Api,
                        }}>
                        {({isLoading, response}) =>
                            _.isFunction(children)
                                ? children({
                                    isLoading,
                                    initialValues: getResponseItem(response),
                                })
                                : children
                        }
                    </Async>
                )
                break
            default:
                break
        }
        return (
            <Modal
                className="custom-modal"
                footer={null}
                title={title}
                onCancel={onCancel}
                open={action?.type}
                destroyOnHidden={true}
                {...modal_params}>
                <Wrapper>
                    {({isLoading, initialValues}) => {
                        if (!!isLoading) {
                            return <LoadingBlock/>
                        }
                        return (
                            <Content
                                {...params}
                                initialValues={initialValues}
                            />
                        )
                    }}
                </Wrapper>
            </Modal>
        )
    }, [action])

    const refresh_deps = useMemo(
        () => [
            shop_id,
            refreshKey,
            JSON.stringify(keyword),
            `refreshToken=${_.get(location.state, 'refreshToken')}`,
        ],
        [shop_id, keyword, refreshKey, location.state]
    )

    const [pager_widget] = usePaginationHelper({
        filter_params: {
            shop_id,
            keyword
        },
        onInit: ({onSortChange = NullAsDefault, onFilterChange = NullAsDefault}) => {
            onFilterChange({
                status,
                keyword
            })
            onSortChange(sortBy)
        },
        pagerInfo: {
            RenderEntity: React.Fragment,
            renderItem: renderManagedProduct({
                translate: t,
                renderContextMenu: renderContextMenu,
                renderActions: renderActions,
                statusFilter: status
            }),
            apiInfo: shop_getProducts_Api,
            query: bindQueryParams([{id: shop_id}]),
            PaginationMeta: renderGridMeta,

            renderWrap: (child, __, count) => !!count
                ? (
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        {child}
                    </div>
                )
                : (
                    <div className="flex flex-col gap-6">
                        {child}
                    </div>
                ),
        },
        SortByWidget: NullAsDefault,
        renderSortBy: NullAsDefault,
        isToggleDefault: true,
        query_params: filter_actions,
        dependencies: [shop_id, keyword],
        withKey: createPagerKey(refresh_deps),
        AdvancedFilter: NullAsDefault,
        renderFilter: NullAsDefault,
        // renderHeader: ([searchBar, filterBar]) => (
        //     <div className="flex flex-col gap-4 mt-4">
        //         {filterBar}
        //         {search_widget}
        //     </div>
        // ),
    })
    return (
        <div className="flex flex-col flex-1 space-y-3 111-111">
            {pager_widget}
            {modal}
            <div className="h-16"/>
        </div>
    )
}

export const ShopProductsSearchBinding = ({...props}) => bindingSearch(props)(ShopProducts)

export default compose(
    branch(
        ({shop_id}) => {
            return _.some([shop_id], _.isEmpty)
        },
        () => () => <ContentNotFound/>
    )
)(ShopProducts)
